export const prefix = 'common_';

export const SET_VOICE_STATE = `${prefix}set_voice_state`;
